import React from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Card,
  Stack,
} from '@mui/material';
import { Person as PersonIcon, Business as BusinessIcon } from '@mui/icons-material';

const AccountSelectDialog = ({ open, accounts, onClose, onSelect }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          bgcolor: '#F8F9FA',
          maxHeight: '80vh',
          m: 2
        }
      }}
    >
      <DialogContent sx={{ p: 2 }}>
        <Stack spacing={2} sx={{ maxHeight: '70vh', overflowY: 'auto' }}>
          {accounts?.map((account) => (
            <Card
              key={account.id}
              onClick={() => onSelect(account)}
              elevation={0}
              sx={{
                bgcolor: 'white',
                borderRadius: '12px',
                p: 2,
                border: '1px solid #EFF6FF',
                boxShadow: '0px 1px 3px 0px #0000001A'
              }}
            >
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                mb: 1 
              }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: account.accountType === '0' ? '#1D4ED8' : '#7E22CE',
                    bgcolor: account.accountType === '0' ? '#EFF6FF' : '#FAF5FF',
                    px: 2,
                    py: 0.75,
                    borderRadius: 4,
                    fontSize: '0.875rem',
                    fontWeight: 500
                  }}
                >
                  {account.accountType === '0' ? 'Individual' : 'Company'}
                </Typography>
                {account.accountType === '0' ? (
                  <PersonIcon sx={{ 
                    color: '#2563EB',
                    fontSize: 32
                  }} />
                ) : (
                  <BusinessIcon sx={{ 
                    color: '#9333EA',
                    fontSize: 36
                  }} />
                )}
              </Box>

              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 900,
                  fontSize: '18px',
                  mb: 1,
                  mt: 1,
                  color: '#111111',
                  fontFamily: 'Roboto'
                }}
              >
                {account.accountType === '0' 
                  ? `${account.firstName} ${account.lastName}`
                  : account.companyName}
              </Typography>
{/* 
              <Typography 
                variant="body2" 
                sx={{
                  color: '#6B7280',
                  fontSize: '12px',
                  fontFamily: 'Roboto',
                  fontWeight: 400
                }}
              >
                {account.accountType === '0'
                  ? `Family Members: ${account.filingStatus === '2' ? '2' : '1'}`
                  : `Entity Type: Limited Liability Company`}
              </Typography> */}
            </Card>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default AccountSelectDialog; 